import React from 'react';
import { motion } from 'framer-motion';
import { XCircleIcon } from 'lucide-react';
const problems = ['No sabe cuál es la siguiente pregunta.', 'Improvisa esperando que la conversación avance.', 'Repite las mismas preguntas de siempre.', 'Pierde oportunidades de profundizar.', 'Termina la consulta pensando: “Había algo más… pero no supe cómo llegar.”'];
export function ProblemSection() {
  return <section className="bg-[#faf6fb] px-4 py-14" data-id="element-202" data-mp="39gul45mmaqkz">
      <div className="mx-auto max-w-md text-center" data-id="element-203" data-mp="35garvd560744">
        <h2 className="font-display text-3xl font-bold leading-tight text-plum" data-id="element-204" data-mp="35fiwa2bki9du">
          Una sola pregunta puede cambiar toda una sesión.
        </h2>
        <p className="mt-3 text-lg font-semibold text-magenta" data-id="element-205" data-mp="3egz3y2azzxed">
          Pero solo si haces la correcta.
        </p>

        <p className="mt-6 text-[15px] leading-relaxed text-plum/70" data-id="element-206" data-mp="1p1j0n3jr95we">
          La mayoría de terapeutas no tiene problemas por falta de conocimiento. Los tiene porque,
          en medio de la sesión…
        </p>

        <div className="mt-6 space-y-3 text-left" data-id="element-207" data-mp="je6bqo5vg03n">
          {problems.map((p, i) => <motion.div key={p} initial={{
          opacity: 0,
          x: -12
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.05
        }} className="flex items-start gap-3 rounded-2xl border border-rose-100 bg-white p-4 shadow-sm" data-id="element-208" data-mp="obezd49sgwca" data-mpi={i}>
              <XCircleIcon className="mt-0.5 h-5 w-5 flex-shrink-0 text-rose-400" data-id="element-209" data-mp="125phv3v6zu9w" />
              <span className="text-sm font-medium text-plum/80" data-id="element-210" data-mp="170uzvrlh4osp">{p}</span>
            </motion.div>)}
        </div>

        <p className="mt-7 text-[15px] leading-relaxed text-plum/70" data-id="element-211" data-mp="1bzy1t365qewg">
          Y esa incertidumbre genera{' '}
          <span className="font-semibold text-plum" data-id="element-212" data-mp="3dtf925qdldqo">ansiedad, inseguridad</span> y sesiones que
          podrían haber sido mucho más profundas.
        </p>

        <div className="mt-6 rounded-2xl bg-plum p-5 text-white shadow-lg" data-id="element-213" data-mp="3hv0vahosv4dj">
          <p className="text-[15px] leading-relaxed" data-id="element-214" data-mp="p1btc3bu5iwk">
            <span className="font-bold text-pink" data-id="element-215" data-mp="k15w87msr473">El Oráculo de las Preguntas</span> fue creado
            precisamente para eliminar esa incertidumbre.
          </p>
        </div>
      </div>
    </section>;
}